import { Injectable } from '@angular/core';

export type LogLevel = 'error' | 'warn' | 'info';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {
  level: LogLevel = 'info';

  log<T>(item: T, level: LogLevel = 'info'): T {
    console.log(`[${level.toUpperCase()}]`, item);

    return item;
  }

  setLogLevel(level: LogLevel) {
    this.level = level;
  }
}
